import React from 'react';
import { connect } from "react-redux";
import { QrReader } from 'react-qr-reader';
import { getQRDetailsUsingScanner } from "../../action/qrcode";

const QRScanner = ({
    qrCodeScanDetailsHandler,

}) => {

    const isIgnorableScannerError = (error) => {
        if (!error) {
            return true;
        }
        const errorMessage = (error.message || error.name || String(error)).toLowerCase();
        return errorMessage.includes("notfound") || errorMessage.includes("timeout");
    };

    const handleScanResult = (data) => {
        if (data) {
            getQRDetailsUsingScanner(data.text)
                .then((data) => {
                    //setAlert("QR Code Scan Successful", "success")
                    qrCodeScanDetailsHandler(data)
                })
                .catch((error) => {
                    console.log('QR Code Scan Error' + error)
                    qrCodeScanDetailsHandler(undefined, error)
                    //setAlert(error, "danger")
                })
        }
    };

    return (
        <div>
            <QrReader
                delay={300}
                onResult={(result, error) => {
                    if (result) {
                        handleScanResult(result);
                        return;
                    }
                    if (error && !isIgnorableScannerError(error)) {
                        console.error(error);
                    }
                }}
                style={{ width: '100%' }}
                videoContainerStyle={{ paddingTop: '80%' }}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps)(QRScanner);


